<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Report By" >
              <v-select :options="reportTypeList" v-model="reportType" placeholder="Select Report Type"></v-select>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Year" v-if="reportType != 'Yearly'">
              <v-select :options="yearList" v-model="year" placeholder="Select Year"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-button variant="primary" class="pull-right" @click="search" :disabled="!isValid">
              Search
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card v-if="reportData" title="Occupancy (%)">
      <occupancy-overview-table :reportData="reportData" :type="'occupancy'"></occupancy-overview-table>
    </b-card>

    <b-card v-if="reportData" title="People Stayed">
      <occupancy-overview-table :reportData="reportData" :type="'people'"></occupancy-overview-table>
    </b-card>

    <b-card v-if="reportData" title="Total Rooms">
      <occupancy-overview-table :reportData="reportData" :type="'rooms'"></occupancy-overview-table>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import { required } from "vuelidate/lib/validators"
  import OccupancyOverviewTable from './OccupancyOverviewTable'


  export default {
    name: 'OccupancyOverview',
    components: {
      OccupancyOverviewTable
    },
    computed: {
      isValid() {
        if (this.reportType) {
          return true
        }

        return this.reportType && this.year
      }
    },
    data: function () {
      return {
        yearList: [],
        reportType: null,
        year: null,
        reportTypeList: ['Weekly', 'Monthly', 'Yearly'],
        reportData: null,
      }
    },
    methods: {
      search() {
        this.reportData = null
        let params = {
          type: this.reportType,
          year: this.year,
        }
        Vue.axios.get('/admin/reports/occupancy-overview', {params: params})
          .then(response => {
            if (response.data.data) {
              this.reportData = response.data
              this.showSuccessMsg()
            } else {
              this.showWarningMsg({message: "No Report Data"})
            }
          })
          .catch(() => {
            this.showErrorMsg()
          })
      },
    },
    created () {
      Vue.axios.get('/admin/reports/years')
        .then(response => {
          _.each(response.data, (year) => {
            this.yearList.push(year)
          })
        })
        .catch((error) => {
          this.showErrorMsg({message: error})
        })
    }
  }
</script>
